<!-- Toast Messages - Positioned at root level -->
<p-toast
  data-testid="warehouse-list-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [life]="4000"
  [preventDuplicates]="false"
></p-toast>

<div data-testid="warehouse-list-page" class="px-6 pt-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "warehouse.management.title" | translate }}
  </h2>

  <!-- Search Form -->
  <app-search-form
    data-testid="warehouse-list-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onAddWarehouse()"
        (secondaryButtonClick)="onDeleteSelected()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      data-testid="warehouse-list-table"
      [dataSource]="warehousesData()"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [first]="first()"
      [rows]="rows()"
      [hasCheckColumn]="wms_delete()"
      [selection]="selectedWarehouses()"
      scrollHeight="flex"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <div class="flex items-center justify-center gap-1">
        <p-tag
          data-testid="warehouse-list-status-tag"
          [value]="getStatusDisplayText(rowData.status)"
          [severity]="getStatusSeverity(rowData.status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(rowData.status)"
          pTooltip="{{ rowData.status ? 'Active' : 'Inactive' }}"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-warehouse>
      <div class="flex items-center gap-2 justify-center">
        @if (wms_update()) {
          <app-button
            [testId]="'warehouse-list-action-edit-' + warehouse.id"
            class="action-edit"
            [label]="'warehouse.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(warehouse)"
          ></app-button>
        }

        @if (wms_approve()) {
          <app-button
            [testId]="
              'warehouse-list-action-' +
              (warehouse.status ? 'deactivate' : 'activate') +
              '-' +
              warehouse.id
            "
            [class]="warehouse.status ? 'action-disable' : 'action-enable'"
            [label]="
              (warehouse.status
                ? 'warehouse.actions.deactivate'
                : 'warehouse.actions.activate'
              ) | translate
            "
            type="action"
            (emitOnClick)="onStatusChange(warehouse)"
          ></app-button>
        }

        @if (wms_delete() && !warehouse.status) {
          <app-button
            [testId]="'warehouse-list-action-delete-' + warehouse.id"
            class="action-delete"
            [label]="'warehouse.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDelete(warehouse)"
          ></app-button>
        }
      </div>
    </ng-template>
    </app-data-table>
  </div>

  <!-- Confirmation Dialog -->
  <app-confirmation-dialog
    data-testid="warehouse-list-confirmation-dialog"
    [visible]="showConfirmationDialog"
    [title]="dialogTitle"
    [message]="dialogMessage"
    [buttons]="dialogButtons"
    (emitOnClick)="onDialogAction($event)"
  ></app-confirmation-dialog>
</div>
